<div class="mb-5 mt-5 pb-0" *ngIf="tagCloudData.length > 0 || USERID != ''">
  <!-- Header with Icon -->
  <div class="d-flex align-items-center gap-3 mb-4">
    <div
      class="bg-primary-subtle text-primary rounded-circle d-flex align-items-center justify-content-center icon-circle-lg">
      <i class="bi bi-tag-fill fs-4"></i>
    </div>
    <div>
      <h5 class="fw-bold text-dark mb-0">{{ 'TagCloud' | translate }}</h5>
      <div class="text-muted small">{{ 'TagCloudSub' | translate }}</div>
    </div>
  </div>

  <ngx-spinner bdOpacity="0.9" bdColor="" size="default" color="#581f87" type="ball-pulse-sync" [fullScreen]="false">
  </ngx-spinner>

  <!-- Tag List -->
  <div class="tag-container mb-4">
    <a *ngFor="let item of tagCloudData" target="_blank"
      [href]="'results?Ntk=TAGSFACET' + ntkLocation + '&Ntt=%22' + item.Value + '%22' + nttLocation" 
      class="tag-badge">
      <span>#</span>{{ item.Value }}
    </a>
  </div>

  <!-- Tag Input Form -->
  <div *ngIf="USERID!=''" class="tag-input-wrapper">
    <form class="example-form" [formGroup]="addFG">
      <div class="input-group mb-0 shadow-sm rounded-pill bg-white" style="max-width: 450px; border: 1px solid rgba(0,0,0,0.08);">
        <span class="input-group-text bg-transparent border-0 rounded-start-pill ps-4 text-muted">
          <i class="bi bi-bookmark-plus text-primary"></i>
        </span>
        <input type="text" class="form-control border-0 py-2 shadow-none bg-transparent" [placeholder]="'TagWord' | translate"
          formControlName="value" [attr.aria-label]="'TagWord' | translate">
        <button [disabled]="!addFG.valid" (click)="AddTag()" class="btn btn-walai px-4 rounded-pill m-1"
          type="button">
          <i class="bi bi-plus-lg me-1"></i> {{ 'Add' | translate }}
        </button>
      </div>
    </form>

    <!-- Tag Suggestions -->
    <div *ngIf="MytagCloud.length > 0" class="mt-4">
      <p class="text-muted small fw-medium mb-2">{{ 'OrSelectThese' | translate }}</p>
      <div class="tag-container">
        <button (click)="ConfirmAddTag(item.TAGSWORD, 2)" *ngFor="let item of MytagCloud"
          class="btn btn-walai px-4 rounded-pill m-1" type="button" style="padding: 6px 14px; font-size: 0.85rem;">
          <span>+</span> {{item.TAGSWORD}}
        </button>
      </div>
    </div>
  </div>
</div>